import { RootStores } from '../../common/stores';
import { STORE_PROJECTS_ROOT_UI, STORE_USERS } from '../../common/constants';
import { STORE_HISTORY, STORE_ADMINISTRATION_HISTORY } from './constants';
import { GlobalAdministrationService } from '../../administration/service/GlobalAdministrationService';
import HistoryStore from './HistoryStore';
import AdministrationHistoryStore from './AdministrationHistoryStore';
import HistoryService from '../services/HistoryService';

export { default as HistoryStore } from './HistoryStore';
export { default as AdministrationHistoryStore } from './AdministrationHistoryStore';

export function injectHistoryStores(obj: RootStores) {
    const historyService = new HistoryService();
    const globalAdministrationService = new GlobalAdministrationService();

    obj[STORE_HISTORY] = new HistoryStore(obj[STORE_PROJECTS_ROOT_UI], obj[STORE_USERS], historyService);
    obj[STORE_ADMINISTRATION_HISTORY] = new AdministrationHistoryStore(
        obj[STORE_USERS],
        historyService,
        globalAdministrationService
    );
}

export type HistoryStores = {
    [STORE_HISTORY]?: HistoryStore;
    [STORE_ADMINISTRATION_HISTORY]?: AdministrationHistoryStore;
};
